import { ReactElement, memo } from 'react';

import { PointAddressSelectorMenuItemProps } from './types';
import {
  PointAddressSelectorMenuItemAccessFeatureContainer,
  PointAddressSelectorMenuItemContainer,
} from './styles';

const PointAddressSelectorMenuItem = ({
  validSubscriptionFeature,
  ...restProps
}: PointAddressSelectorMenuItemProps): ReactElement => {
  if (validSubscriptionFeature) {
    return (
      <PointAddressSelectorMenuItemAccessFeatureContainer
        {...validSubscriptionFeature}
        {...restProps}
      />
    );
  }

  return <PointAddressSelectorMenuItemContainer {...restProps} />;
};

export default memo(PointAddressSelectorMenuItem);
